export function cmToPixels(cm) {
    var cpi = 2.54; // centimeters per inch
    var dpi = 96; // dots per inch
    var ppd = window.devicePixelRatio; // pixels per dot
    return cm * dpi * ppd / cpi;
}